jQuery(function($) {
  $('.js-pagetop').on('click', function(e) {
      e.preventDefault();

      $('html, body').animate({
          scrollTop: 0
      }, 800);
  });
});
